import axiosInstance from './axiosInstance';

/**
 * Common GET request function
 * @param {string} endpoint - API endpoint
 * @returns {Promise<any>} - API response
 */
export const getRequest = async (endpoint) => {
  try {
    const response = await axiosInstance.get(endpoint);
    return response;
  } catch (error) {
    console.error(`GET request to ${endpoint} failed:`, error);
    throw error;
  }
};

/**
 * Common POST request function
 * @param {string} endpoint - API endpoint
 * @param {object} payload - Data to be sent in the request body
 * @returns {Promise<any>} - API response
 */
export const postRequest = async (endpoint, payload) => {
  try {
    const response = await axiosInstance.post(endpoint, payload);
    return response;
  } catch (error) {
    console.error(`POST request to ${endpoint} failed:`, error);
    throw error;
  }
};


export const postRequestWithHeaders = async (endpoint, payload, headers) => {
  try {
    const response = await axiosInstance.post(endpoint, payload,headers);
    return response;
  } catch (error) {
    console.error(`POST request to ${endpoint} failed:`, error);
    throw error;
  }
};

/**
 * Common PUT request function
 * @param {string} endpoint - API endpoint
 * @param {object} payload - Data to be sent in the request body
 * @returns {Promise<any>} - API response
 */
export const putRequest = async (endpoint, payload) => {
  try {
    const response = await axiosInstance.put(endpoint, payload);
    return response;
  } catch (error) {
    console.error(`PUT request to ${endpoint} failed:`, error);
    throw error;
  }
};

/**
 * Common DELETE request function
 * @param {string} endpoint - API endpoint
 * @returns {Promise<any>} - API response
 */
export const deleteRequest = async (endpoint) => {
  try {
    const response = await axiosInstance.delete(endpoint);
    return response;
  } catch (error) {
    console.error(`DELETE request to ${endpoint} failed:`, error);
    throw error;
  }
};
